import React, { useEffect, useState } from 'react';
import EditIcon from '../../../../Assets/OptionsModel/edit.svg';
import UserIcon from "../../../../Assets/Account/NameIcon.svg";
import ProfileIcon from "../../../../Assets/Account/MyProfile.svg";
import BankIcon from "../../../../Assets/Account/bankIcon.svg";
import { getBusinessInfo, updatePaymentInfo } from '../../../../lib/utils/apiCalls';
import { showToast } from '../../../../Components/Toaster/Toaster';

function SectionBox({ icon, title, value, border }) {
    return (
        <div className={`p-[10px] flex items-center gap-3 ${border && 'border-b border-[#EAEAEA]'}`}>
            <div className="size-6 flex items-center justify-center">
                <img className='size-full' src={icon} alt="" />
            </div>

            <div className="flex flex-col gap-1 font-medium">
                <h1 className='text-[14px] leading-5 text-[#808080]'>{title}</h1>

                <p className='text-[16px] leading-5 text-[#000000]'>{value}</p>
            </div>
        </div>
    )
}

function PaymentInfo() {
    const [editFormOpen, setEditFormOpen] = useState(false);

    const [paymentInfo, setPaymentInfo] = useState({});
    const defaultFormInputs = {
        accountHolderName: '',
        accountNumber: '',
        ifscCode: ''
    };
    
    const [formInputs, setFormInputs] = useState(defaultFormInputs);
    const [formErrors, setFormErrors] = useState(defaultFormInputs);

    function handleChange(e) {
        const { name, value } = e.target;

        setFormInputs({ ...formInputs, [name]: value });
    }

    async function fetchSellerPaymentInfo() {
        try {
            const response = await getBusinessInfo();
            if(response.status === 200) {
                setPaymentInfo(response.data.data.seller);
                setFormInputs({
                    accountHolderName: response.data.data.seller.accountHolderName,
                    accountNumber: response.data.data.seller.accountNumber,
                    ifscCode: response.data.data.seller.ifscCode,
                });
            }
        }
        catch(err) {
            console.log(err);
        }
    }

    useEffect(() => {
        fetchSellerPaymentInfo();
    }, []);

    function handleEditProfile() {
        setEditFormOpen(true);
    }

    function handleCancelForm() {
        setEditFormOpen(false);
    }

    async function handleSubmit() {
        const validationErrors = {};

        if(!formInputs.accountHolderName) {
            validationErrors.accountHolderName = 'Required field';
        }

        if(!formInputs.accountNumber) {
            validationErrors.accountNumber = 'Required field';
        }

        if(!formInputs.ifscCode) {
            validationErrors.ifscCode = 'Required field';
        }

        if(Object.keys(validationErrors).length === 0) {
            setFormErrors(defaultFormInputs);

            try {
                const response = await updatePaymentInfo(formInputs);

                if(response.status === 200) {
                    showToast('Payment info updated.', 'success');
                    handleCancelForm();
                    fetchSellerPaymentInfo();
                }
            }
            catch(err) {
                showToast(err, 'error');
            }
        }
        else {
            setFormErrors(validationErrors);
        }
    }

    return (
        <div className='w-3/5 flex flex-col gap-4'>
            {
                editFormOpen ? 
                <div className='flex flex-col gap-4'>
                    <h1 className='font-semibold text-[20px] leading-6 text-[#121212]'>Payment Information</h1>

                    <div className="flex flex-col gap-4">
                        <div className="border border-[#EAEAEA] p-4 flex flex-col gap-6">
                            <div className="flex items-center justify-between">
                                <label htmlFor="accountHolderName" className='cursor-pointer font-medium text-[16px] leading-5 text-[#000000]'>Account Holder Name</label>

                                <div className="w-[70%] flex flex-col gap-2">
                                    <input 
                                        name='accountHolderName' 
                                        id='accountHolderName' 
                                        className='outline-none w-full border border-[#EAEAEA] bg-[#F5F5F5] px-3 py-4 rounded-lg font-normal text-base placeholder:text-[#666666] text-[#000000]'
                                        type="text" 
                                        placeholder='enter account holder name' 
                                        value={formInputs.accountHolderName} 
                                        onChange={handleChange} 
                                    />

                                    {
                                        formErrors.accountHolderName && 
                                        <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{formErrors.accountHolderName}</p>
                                    }
                                </div>
                            </div>

                            <div className="flex items-center justify-between">
                                <label htmlFor="accountNumber" className='cursor-pointer font-medium text-[16px] leading-5 text-[#000000]'>Account Number</label>

                                <div className="w-[70%] flex flex-col gap-2">
                                    <input 
                                        name='accountNumber' 
                                        id='accountNumber' 
                                        className='outline-none w-full border border-[#EAEAEA] bg-[#F5F5F5] px-3 py-4 rounded-lg font-normal text-base placeholder:text-[#666666] text-[#000000]'
                                        type="text" 
                                        placeholder='enter account number' 
                                        value={formInputs.accountNumber} 
                                        onChange={handleChange} 
                                    />

                                    {
                                        formErrors.accountNumber && 
                                        <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{formErrors.accountNumber}</p>
                                    }
                                </div>
                            </div>

                            <div className="flex items-center justify-between">
                                <label htmlFor="ifscCode" className='cursor-pointer font-medium text-[16px] leading-5 text-[#000000]'>IFSC Code</label>

                                <div className="w-[70%] flex flex-col gap-2">
                                    <input 
                                        name='ifscCode' 
                                        id='ifscCode' 
                                        className='outline-none w-full border border-[#EAEAEA] bg-[#F5F5F5] px-3 py-4 rounded-lg font-normal text-base placeholder:text-[#666666] text-[#000000]'
                                        type="text" 
                                        placeholder='enter ifsc code' 
                                        value={formInputs.ifscCode} 
                                        onChange={handleChange} 
                                    />

                                    {
                                        formErrors.ifscCode && 
                                        <p className='text-[14px] leading-5 text-[#DC2626] select-none'>{formErrors.ifscCode}</p>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="ml-auto flex items-center gap-3 font-semibold text-base text-[#121212]">
                            <button onClick={handleCancelForm} className='border border-[#808080] rounded px-4 py-2'>Cancel</button>

                            <button onClick={handleSubmit} className='bg-primaryColor hover:bg-primaryAccent rounded px-4 py-2 text-buttonText'>Save Changes</button>
                        </div>
                    </div>
                </div> : 
                <div className="p-4 flex flex-col gap-4 rounded-xl border-b border-[#EAEAEA] shadow-[0_0_6px_0_#0000001F]">
                    <div className="flex items-center justify-between">
                        <h1 className='font-semibold text-[20px] leading-6 text-[#121212]'>Payment Information</h1>

                        <button onClick={handleEditProfile} className="outline-none size-6 flex items-center justify-center">
                            <img className='size-full' src={EditIcon} alt="" />
                        </button>
                    </div>

                    <div className="flex flex-col gap-4 p-4">
                        <SectionBox 
                            icon={UserIcon} 
                            title={'Account Holder Name'} 
                            value={paymentInfo.accountHolderName} 
                            border 
                        />

                        <SectionBox 
                            icon={ProfileIcon} 
                            title={'Account Number'} 
                            value={paymentInfo.accountNumber} 
                            border 
                        />

                        <SectionBox 
                            icon={BankIcon} 
                            title={'IFSC Code'} 
                            value={paymentInfo.ifscCode} 
                        />
                    </div>
                </div>
            }
        </div>
    );
}

export default PaymentInfo;
